import { render, staticRenderFns } from "./ReportContentCategories.vue?vue&type=template&id=aa83bc54&scoped=true"
import script from "./ReportContentCategories.vue?vue&type=script&lang=ts"
export * from "./ReportContentCategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa83bc54",
  null
  
)

export default component.exports